module.exports = __webpack_public_path__ + "static/media/floating_island.814c90f6.glb";